import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { AuthenticationService } from "@sick-bust-sts/sts-core";

@Component({
  selector: "app-project-migration",
  templateUrl: "./project-migration.component.html",
  styleUrls: ["./project-migration.component.css"],
  standalone: false,
})
export class ProjectMigrationComponent implements OnInit {
  constructor(
    private router: Router,
    private authenticationService: AuthenticationService,
  ) {}

  ngOnInit(): void {
    if (!this.authenticationService.isLoggedIn()) {
      void this.router.navigate(["login"]);
    }
  }
}
